// extracted by mini-css-extract-plugin
export var dotPulse = "layout-module--dotPulse--0i6Zp";
export var dotPulseAfter = "layout-module--dotPulseAfter--2ZB9u";
export var dotPulseBefore = "layout-module--dotPulseBefore--RmmDE";
export var header = "layout-module--header--R1XBo";
export var main = "layout-module--main--5VKR9";
export var nav = "layout-module--nav--f9S34";